import React from 'react';
import ReactDom from 'react-dom';

import PopularArticlesList from '../Components/PopularArticles/index.jsx';
import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';

import popularArticles from '../Services/PopularArticles/index.jsx';

export default function (document) {
  var elements = document.querySelectorAll('[data-react-component="cs-popular-articles"]');
  if (elements && elements.length) {    
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      ReactDom.render(
        <ErrorBoundary>
          <PopularArticlesList mostPopularArticles={popularArticles} />
        </ErrorBoundary>,
        element
      );
    }
  }
}
